// extracted by mini-css-extract-plugin
module.exports = {"main":"Notifications_main__Gzmo1","box":"Notifications_box__OCGHG"};